export default "__VITE_ASSET__BHkrvtFN__"